<div class="box">

  <div class="pill" [style.background-image]="statesService.backgroundImageSrc + statesService.imageNumber + '.webp'">
</div>

</div>
